import { Directive, OnInit, ElementRef, HostListener } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
    selector: '[UpperCase]'
})
export class UpperCaseDirective {

    constructor(private el: ElementRef, private control: NgControl) {
    }

    @HostListener('input', ['$event']) onEvent($event) {
        const str: string = this.control.value;
        this.control.control.setValue(str.toUpperCase());
    }

}


@Directive({
    selector: '[LowerCase]'
})
export class LowerCaseDirective {

    constructor(private el: ElementRef, private control: NgControl) {
    }

    @HostListener('input', ['$event']) onEvent($event) {
        const str: string = this.control.value;
        this.control.control.setValue(str.toLowerCase())
    }

}